import { createSelector } from 'reselect';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { containsDestinationConflictItems } from 'swag-client-common/utils/cart.util';
import { CART_LINK_PREFIX } from 'swag-common/constants/main-swag.constants';
import { getCartItemsCount } from 'swag-common/utils/get-cart-items-count.util';
import { PreBuiltCartType } from 'swag-common/constants/reseller.constants';
import { PromocodeMeasurementEnum } from 'swag-common/constants/promocode';
const rootSelector = state => state.cart;
export const cartItemsSelector = createSelector(rootSelector, cart => cart.items);
const cartBadgeIsLoadingStateSelector = createSelector(rootSelector, cart => cart.cartBadgeIsLoading);
const isLoadingSelector = createSelector(rootSelector, cart => cart.isLoading);
const deletingItemIdSelector = createSelector(rootSelector, cart => cart.deletingItemId);
export const orderTokenSelector = createSelector(rootSelector, cart => cart.orderToken);
export const orderVersionSelector = createSelector(rootSelector, cart => cart.orderVersion);
export const draftVersionSelector = createSelector(rootSelector, cart => cart.draftVersion);
export const draftTokenSelector = createSelector(rootSelector, cart => cart.draftToken);
export const cartItemsCountSelector = createSelector(cartItemsSelector, getCartItemsCount);
const cartDeletingItemSelector = createSelector(cartItemsSelector, deletingItemIdSelector, (items, deletingItemId) => {
  return items.find(item => item._id === deletingItemId);
});
export const isReducingDeletingItemSelector = createSelector(cartItemsSelector, cartDeletingItemSelector, (items, deletingItem) => {
  if (!deletingItem || !deletingItem.boxItemsId) {
    return true;
  }
  return items.filter(item => item.boxItemsId === deletingItem.boxItemsId).length < 3;
});
export const cartBadgeIsLoadingSelector = createSelector(isReducingDeletingItemSelector, cartBadgeIsLoadingStateSelector, isLoadingSelector, (isReducingDeletingItem, cartBadgeIsLoading, isLoading) => (cartBadgeIsLoading || isLoading) && isReducingDeletingItem);
export const containsDestinationConflictItemsSelector = createSelector(cartItemsSelector, containsDestinationConflictItems);
export const preBuiltCartLinkSelector = createSelector(rootSelector, cart => {
  const origin = window.location.origin;
  return `${origin}${CART_LINK_PREFIX}${cart.preBuiltCartShortId}${APP_ROUTES.CART}`;
});
export const preBuiltCartTypeSelector = createSelector(rootSelector, cart => {
  return cart === null || cart === void 0 ? void 0 : cart.preBuiltCartType;
});
export const isPreBuiltCartSelector = createSelector(preBuiltCartTypeSelector, Boolean);
export const isPreBuiltLimitedCartSelector = createSelector(preBuiltCartTypeSelector, type => type === PreBuiltCartType.PreBuiltLimited);
export const isPreBuiltLimitedCartOpenedByCustomerSelector = createSelector(isPreBuiltLimitedCartSelector, isPreBuiltLimitedCart => {
  var _window, _window$location;
  const CART_LINK_PREFIX = '/cart-link/';
  const isOpenedByCustomer = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname.includes(CART_LINK_PREFIX);
  return isPreBuiltLimitedCart && isOpenedByCustomer;
});
export const cartOrderIdSelector = createSelector(rootSelector, cart => {
  return cart._id;
});
export const cartOrderDiscountsSelector = createSelector(rootSelector, cart => {
  const {
    measurement,
    IS_FREE_SETUP_FEE,
    IS_FREE_SHIPPING,
    IS_TAXFREE,
    promocodeDiscount
  } = cart;
  const discountValueAmount = measurement === PromocodeMeasurementEnum.ABSOLUTE ? promocodeDiscount / 100 : promocodeDiscount;
  return {
    discountType: measurement,
    discountValue: discountValueAmount,
    freeTax: IS_TAXFREE,
    freeSetupFee: IS_FREE_SETUP_FEE,
    freeShipping: IS_FREE_SHIPPING
  };
});
export const cartShipmentTotalSelector = createSelector(rootSelector, cart => {
  return cart.shipmentCustomerTotal;
});
export const cartTotalSelector = createSelector(rootSelector, cart => {
  return (cart === null || cart === void 0 ? void 0 : cart.total) || 0;
});